import unionize, {ofType, UnionOf} from 'unionize';
import {SavedAgentMapping} from 'Users/models/AgentMapping';
import {SavedFieldSalesLeader} from 'Users/models/FieldSalesLeader';
import {SavedFieldVicePresident} from 'Users/models/FieldVicePresident';
import {SavedVip} from 'Users/models/Vip';

export const User = unionize({
  AgentUser: ofType<SavedAgentMapping>(),
  FieldSalesLeader: ofType<SavedFieldSalesLeader>(),
  FieldVicePresident: ofType<SavedFieldVicePresident>(),
  Vip: ofType<SavedVip>(),
});

export type UserUnion = UnionOf<typeof User>;
